export const socketEventsHandlerDelays = {
  betsClosedDelay: 4000,
  roundStartDelay: 1000,
  doBetResultDelay: 4100,
  roundFinDelay: 5000,
};
